<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
               [attr.role]="'navigation'"
               mode="'side'"
               opened="false">
    <mat-toolbar>
      <div *ngIf="drawer.opened" class="col text-center">
        <i class="material-icons align-middle">wb_sunny</i>
        <mat-slide-toggle class="mx-2" (toggleChange)="onThemeChange()" [checked]="isDarkTheme"></mat-slide-toggle>
        <i class="material-icons align-middle">brightness_3</i>
      </div>
    </mat-toolbar>
    <div *ngIf="user" class="profile-card">
      <div class="navigation-item-label">
        <div class="header">
          <h3>{{ user.first_name }} {{ user.last_name }}</h3>
          <h4 style="color: grey">{{ user.company }}</h4>
        </div>
        <app-user-picture></app-user-picture>
      </div>
    </div>
    <mat-nav-list class="navigation-list">
      <a *ngIf="!drawer.opened" class="dropdown-item" (click)="drawer.toggle()">
        <div class="row">
          <div class="col-2">
            <i class="fas fa-bars fa-lg" title="Menu"></i>
          </div>
          <div class="col-10"></div>
        </div>
      </a>
      <br>
      <app-navigation-item color="rgb(145,145,145)" link="/home" icon="fas fa-home fa-lg" title="Home" [details]="drawer.opened">Home</app-navigation-item>

      <app-navigation-item color="rgb(94,187,75)" link="/resources/portfolio-models" icon="fas fa-chart-bar fa-lg" title="Target Strategies" [details]="drawer.opened">Target Strategies</app-navigation-item>
      <app-navigation-item color="rgb(94,187,75)" link="/resources/glossary" icon="fas fa-book-reader fa-lg" title="Glossary" [details]="drawer.opened">Glossary</app-navigation-item>
      <app-navigation-item color="rgb(94,187,75)" link="/resources/papers" icon="fas fa-leaf fa-lg" title="White Papers" [details]="drawer.opened">White Papers</app-navigation-item>
      <app-navigation-item color="rgb(94,187,75)" link="/resources/webinars" icon="fa fa-film fa-lg" title="Web Seminars" [details]="drawer.opened">Web Seminars</app-navigation-item>
      <app-navigation-item color="rgb(94,187,75)" link="/resources/events" icon="fas fa-calendar-alt fa-lg" title="Events" [details]="drawer.opened">Events</app-navigation-item>

      <app-navigation-item color="rgb(145,145,145)" icon="fas fa-sign-out-alt fa-lg" title="Sign out" [details]="drawer.opened" (click)="onSignOut()">Sign out</app-navigation-item>
    </mat-nav-list>

  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content py-0">
    <app-header [shrinkOffset]="true"></app-header>
    <app-portfolio-models *ngIf="selectedTab=='portfolio-models'"></app-portfolio-models>
    <app-glossary *ngIf="selectedTab=='glossary'"></app-glossary>
    <app-papers *ngIf="selectedTab=='papers'"></app-papers>
    <app-webinars *ngIf="selectedTab=='webinars'"></app-webinars>
    <app-events *ngIf="selectedTab=='events'"></app-events>
    <br>
  </mat-sidenav-content>
</mat-sidenav-container>
